import { reportService, betriebstageBuchService } from "./api";

// Service to handle PDF generation while ensuring German language is used
export const pdfService = {
  // Generate PDF for a report - always uses German language
  generateReportPDF: async (reportId) => {
    try {
      // Pass language parameter and set download to false to avoid automatic download
      return await reportService.getPdf(reportId, {
        language: "de",
        download: false,
      });
    } catch (error) {
      console.error("Error generating PDF:", error);
      throw error;
    }
  },

  // Download the PDF for a report
  downloadReportPDF: async (reportId, filename) => {
    try {
      // Set download to true to trigger automatic download and specify German language
      const response = await reportService.getPdf(reportId, {
        language: "de",
        download: true,
      });

      // The download will be handled by the getPdf function
      return true;
    } catch (error) {
      console.error("Error downloading PDF:", error);
      throw error;
    }
  },

  // Generate PDF for a BetriebstageBuch - always uses German language
  generateBetriebstageBuchPDF: async (entryId) => {
    try {
      return await betriebstageBuchService.getPdf(entryId, {
        language: "de",
        download: false,
      });
    } catch (error) {
      console.error("Error generating BetriebstageBuch PDF:", error);
      throw error;
    }
  },

  // Download the PDF for a BetriebstageBuch
  downloadBetriebstageBuchPDF: async (entryId) => {
    try {
      const response = await betriebstageBuchService.getPdf(entryId, {
        language: "de",
        download: true,
      });

      // The download will be handled by the getPdf function
      return true;
    } catch (error) {
      console.error("Error downloading BetriebstageBuch PDF:", error);
      throw error;
    }
  },
};

export default pdfService;
